import { useMemo } from 'react'
import { toTitleCase } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data || !data.length) return data
    return data.map(d => ({ ...d, text: toTitleCase(d.text) }))
  }, [data])
}
